import angular from "angular";

import ServiceProviderRequestsModuleRouting from "./service-provider-requests.module.routing";

export default angular
  .module("vt-service-provider-requests", [])
  .config(ServiceProviderRequestsModuleRouting);
